import produce from "immer";
import reducerUtils from "../../../store/reducerUtils";
import McpPlaygroundActions from "./mcpPlaygroundActions";

const initialState = {
  data: {
    // list
    playgrounds: null,
    // public playground
    publicPlayground: null,
  },
};

export const mcpPlaygroundSelectors = {
  getPlaygrounds: (state) => state.playgrounds.data.playgrounds,
  getPublicPlayground: (state) => state.playgrounds.data.publicPlayground,
};

const onListLoaded = produce((draft, action) => {
  draft.data.playgrounds = action.playgrounds;
});

const onPublicPlaygroundLoaded = produce((draft, action) => {
  draft.data.publicPlayground = action.playground;
});

const handlers = {
  [McpPlaygroundActions.LIST_LOADED]: onListLoaded,
  [McpPlaygroundActions.PUBLIC_PLAYGROUND_LOADED]: onPublicPlaygroundLoaded,
};

const mcpPlaygroundReducer = reducerUtils.createReducer(initialState, handlers);

export default mcpPlaygroundReducer;
